<template>
  <div
    class="container-wrap"
    :class="{
      disabled: !(
        merchantInfo.withdraw_status === 2 || mainData.withdraw_auth === 2
      ),
    }"
  >
    <div
      class="disable-tip"
      v-if="merchantInfo.withdraw_status === 2 || mainData.withdraw_auth === 2"
    >
      门店的提现功能给禁止使用，不能进行配置
    </div>
    <div class="title text-color">提现银行卡信息</div>
    <div class="flex card-box text-color">
      <div class="flex card-title">
        <div class="font-size-14">银行名称：</div>
        <div class="font-size-14">{{ mainData.nbk_name }}</div>
      </div>
      <div class="flex card-number">
        <div class="font-size-14">银行卡：</div>
        <div class="font-size-14">{{ mainData.acct_no }}</div>
      </div>
    </div>
    <div class="title text-color">提现设置</div>
    <div class="withdrawal-form">
      <div class="withdrawal-item flex">
        <div class="withdrawal-label font-size-14 text-color">
          钱包留存金额：
        </div>
        <div class="withdrawal-content">
          <span class="green font-size-14"
            >{{
              mainData.config ? mainData.config.retained_amount : "-"
            }}元</span
          >
          <span class="gray desc">
            门店正常运营期间，留存金额不支持提现，用于学员退款周转
          </span>
        </div>
      </div>
      <div class="withdrawal-item flex">
        <div class="withdrawal-label font-size-14 text-color">提现模式：</div>
        <div class="withdrawal-content withdrawal-type-wrap flex">
          <div
            class="withdrawal-type"
            :class="{
              active: currentType === 'autoWithdrawal',
              disabled:
                merchantInfo.withdraw_status === 2 ||
                mainData.withdraw_auth === 2,
              borderLeft: currentType === 'handWithdrawal',
            }"
            @click="handleClickType('autoWithdrawal')"
          >
            <div class="text-color font-size-14">自动提现</div>
            <div class="text-color">系统自动发起提现</div>
          </div>
          <div
            class="withdrawal-type"
            @click="handleClickType('handWithdrawal')"
            :class="{
              active: currentType === 'handWithdrawal',
              disabled:
                merchantInfo.withdraw_status === 2 ||
                mainData.withdraw_auth === 2,
              borderRight: currentType === 'autoWithdrawal',
            }"
          >
            <div class="text-color font-size-14">手动提现</div>
            <div class="text-color">需人工手动发起提现</div>
          </div>
        </div>
      </div>
      <div class="withdrawal-item flex" v-if="showTimePicker">
        <div class="withdrawal-label"></div>
        <div class="withdrawal-content time-picker">
          <div class="flex">
            <div class="text text-color font-size-14">按固定时间，每天</div>
            <el-time-picker
              v-model="auto_time"
              :disabled="
                merchantInfo.withdraw_status === 2 ||
                mainData.withdraw_auth === 2
              "
              format="HH:mm"
              @change="handleAutoTime"
            >
            </el-time-picker>
            <div class="text text-color font-size-14">
              发起提现<span class="gray desc">每天只能提现一次</span>
            </div>
          </div>
        </div>
      </div>
      <div class="withdrawal-item flex">
        <div class="withdrawal-label font-size-14 text-color">提现手机号：</div>
        <div class="withdrawal-content">
          <el-select
            v-model="mainData.withdrawalMobile"
            placeholder="请选择员工"
            @change="handleWithdrawalMobile"
            :disabled="
              merchantInfo.withdraw_status === 2 || mainData.withdraw_auth === 2
            "
          >
            <el-option
              v-for="(item, index) in withdrawalMobileList"
              :key="index"
              :label="item.withdrawal_mobile"
              :value="item.staff_id"
            ></el-option>
          </el-select>
          <span class="gray desc">以员工手机号绑定，查收手动提现的验证码</span>
        </div>
      </div>
      <div class="withdrawal-item flex">
        <div class="withdrawal-label font-size-14 text-color">
          提现消息推送员工：
        </div>
        <div class="message-staff flex">
          <el-select
            v-model="mainData.staff_ids"
            placeholder="请选择员工"
            multiple
            @change="handleMessagePushStaff"
            :disabled="
              merchantInfo.withdraw_status === 2 || mainData.withdraw_auth === 2
            "
          >
            <el-option
              v-for="(item, index) in staff_list"
              :key="index"
              :label="item.name"
              :value="item.staff_id"
            ></el-option>
          </el-select>
          <span class="gray desc">
            提现及到账推送消息通知员工，支持同时推送多个员工
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  withdrawalInfoApi,
  withdrawConfigEditApi,
  getMerchantInfoApi,
} from "@/api/storeWallet";
import { staffList } from "@/api/globalSearch";
import { dateFormat } from "@/utils/timeFormat";

export default {
  name: "paySetting",
  data() {
    return {
      mainData: {},
      staff_list: [],
      withdrawalMobileList: [],
      currentType: "autoWithdrawal",
      showTimePicker: true,
      merchantInfo: {},
      auto_time: "",
    };
  },
  created() {
    getMerchantInfoApi().then((res) => {
      this.merchantInfo = res.data;
    });
    this.getWithdrawalInfo();
    this.getStaffList("");
  },
  methods: {
    getWithdrawalInfo() {
      withdrawalInfoApi().then((res) => {
        if (res.error_code === 0) {
          this.showTimePicker =
            res.data.config.auto_switch === 1 ? true : false;
          this.currentType =
            res.data.config.auto_switch === 1
              ? "autoWithdrawal"
              : "handWithdrawal";
          this.mainData = res.data;
          // 处理后端回传的 时分 数据
          this.getHourMinute(res.data.config.auto_time);
          this.mainData.withdrawalMobile = res.data.withdraw_staff.staff_id;
          this.mainData.staff_ids = res.data.message_push_staffs.map((item) => {
            return item.staff_id;
          });
        }
      });
    },
    getStaffList(v) {
      staffList({
        page: 1,
        page_size: 100,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.staff_list = res.data.list;
          this.withdrawalMobileList = res.data.list.map((item) => {
            item.withdrawal_mobile = item.mobile + `(${item.name})`;
            return item;
          });
        }
      });
    },
    // 提现模式编辑
    handleClickType(val) {
      if (
        this.merchantInfo.withdraw_status === 2 ||
        this.mainData.withdraw_auth === 2
      ) {
        return;
      }
      if (val === this.currentType) return;
      this.currentType = val;
      // 提现模式编辑
      withdrawConfigEditApi({
        auto_switch: this.currentType === "autoWithdrawal" ? 1 : 2,
      }).then((res) => {
        if (res.error_code === 0) {
          this.getWithdrawalInfo();
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },

    // 时间编辑
    handleAutoTime() {
      let hour = String(new Date(this.auto_time).getHours()).padStart(2, "0");
      let minute = String(new Date(this.auto_time).getMinutes()).padStart(
        2,
        "0"
      );
      withdrawConfigEditApi({
        auto_time: `${hour}:${minute}`,
      }).then((res) => {
        if (res.error_code === 0) {
          this.getWithdrawalInfo();
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
    // 组件需要接受标准的时间格式，添加当前的年月，再赋值
    getHourMinute(val) {
      let date = dateFormat("YYYY-mm-dd", Date.now());
      let resDate = date + ` ${val}`;
      this.auto_time = new Date(resDate);
    },
    // 提现手机号编辑
    handleWithdrawalMobile() {
      withdrawConfigEditApi({
        staff_id: this.mainData.withdrawalMobile,
      }).then((res) => {
        if (res.error_code === 0) {
          this.getWithdrawalInfo();
          this.$message({
            message: "操作成功",
            type: "success",
          });
        }
      });
    },
    // 消息推送编辑
    handleMessagePushStaff(evt) {
      if (this.mainData.staff_ids.length < 1) {
        this.$message({
          message: "至少有一位员工",
          type: "error",
        });
        return false;
      }
      withdrawConfigEditApi({
        staff_ids: evt,
      }).then((res) => {
        if (res.error_code === 0) {
          this.getWithdrawalInfo();
          this.$message({
            message: "操作成功",
            type: "success",
          });
        } else {
          this.$message({
            message: res.message,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container-wrap {
  border: 1px solid transparent;
  background-color: #ffffff;
  padding: 40px 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  .disable-tip {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(255, 241, 241, 1);
    height: 45px;
    color: red;
    line-height: 45px;
    padding-left: 12px;
  }
  .title {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 700;
  }
  .card-box {
    margin: 18px 0 30px 0;
    padding: 20px;
    background: rgba(246, 250, 252, 1);
    border-radius: 10px;
    .card-title {
      flex: 1;
    }
    .card-number {
      flex: 2;
    }
  }
  .withdrawal-form {
    margin: 18px 0;
    font-size: 14px;
    border: 1px solid rgba(231, 232, 234, 1);
    border-radius: 10px;
    padding: 26px 20px 0 20px;
    .withdrawal-item {
      margin-bottom: 24px;
      .withdrawal-label {
        min-width: 130px;
        text-align: left;
        line-height: 30px;
      }
      /deep/.withdrawal-content {
        height: 30px;
        line-height: 30px;
        .el-input__inner {
          width: 400px;
          height: 30px !important;
          color: rgba(92, 93, 94, 1) !important;
        }
        .el-input__icon {
          height: 35px !important;
        }
      }
      /deep/.time-picker {
        // width: 500px;
        .el-date-editor {
          width: 180px;
          margin: 0 10px;
          .el-input__inner {
            width: 180px;
            height: 30px !important;
          }
          .el-input__icon {
            line-height: 30px;
          }
        }
      }
      .withdrawal-type-wrap {
        height: auto !important;
        line-height: 20px;
        border-radius: 4px;
        overflow: hidden !important;
        .withdrawal-type {
          text-align: center;
          padding: 10px 48px;
          cursor: pointer;
        }
        .withdrawal-type.active {
          background: #07d1aa;
          color: white;
          cursor: default;
          div {
            color: white;
          }
        }
        .withdrawal-type.disabled {
          cursor: not-allowed;
        }
        .withdrawal-type.borderLeft {
          border: 1px solid rgba(231, 232, 234, 1);
          border-radius: 4px 0px 0px 4px;
        }
        .withdrawal-type.borderRight {
          border: 1px solid rgba(231, 232, 234, 1);
          border-radius: 0px 4px 4px 0px;
        }
      }
      /deep/ .message-staff {
        align-items: flex-start;
        .el-select__tags {
          .el-tag {
            background: rgba(246, 250, 252, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0 10px 12px;
            padding: 0 15px 0 0 !important;
            .el-select__tags-text {
              color: rgba(92, 93, 94, 1);
              padding: 0 15px !important;
            }
            .el-tag__close {
              background: white;
              right: 0 !important;
            }
            .el-tag__close::before {
              color: rgba(92, 93, 94, 1);
              font-weight: 700;
            }
          }
        }
        .el-input__inner {
          width: 400px;
          color: rgba(92, 93, 94, 1) !important;
        }
        .el-input__suffix {
          .el-select__caret {
            height: fit-content;
            line-height: 50px;
          }
        }
        .desc {
          margin-top: 10px;
        }
      }
    }
  }
}
.container-wrap.disabled {
  padding: 0px 12px 12px 12px;
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-content: center;
}
.desc {
  margin-left: 15px;
  background: rgba(246, 250, 252, 1);
  padding: 4px 18px;
  border-radius: 4px;
  font-size: 13px;
}
.green {
  color: #07d1aa;
}
.gray {
  color: rgba(158, 159, 160, 1);
}
.text-color {
  color: rgba(92, 93, 94, 1);
}
.font-size-14 {
  font-size: 14px;
}
</style>
